// PRESSABLE_BORDER constants required for calculating appropriate radius for PressableOutline component

export const DEFAULT_PRESSABLE_BORDER_RADIUS = 4;
export const PRESSABLE_BORDER_WIDTH = 1;
